import React, { lazy } from 'react';

import { ClientOnly } from '@/utils/client-only.tsx';

const DirectBuyOrgSetupContainer = lazy(
	() =>
		// @ts-ignore
		import('../../../../../components/signup/post-order/src/layout/direct-buy-org-setup-container.tsx'),
);

export const BuyCloudOrgSetupPageTemplate: React.FC = () => {
	return (
		<ClientOnly>
			<DirectBuyOrgSetupContainer />
		</ClientOnly>
	);
};
